import { captureException, init, showReportDialog } from '@sentry/browser';
import { BrowserTracing } from '@sentry/tracing';
import { Application } from './application';
import { domReady } from './utils/dom-ready.fn';
import { isProd } from './utils/is-prod.fn';

try {
  domReady(async () => {
    try {
      if (isProd()) {
        init({
          dsn: 'https://fa12393c86f044ebab34168ee2ce3236@o241437.ingest.sentry.io/4504482105393152',
          integrations: [new BrowserTracing()],
          tracesSampler: ctx => {
            if (ctx?.transactionContext?.op === 'handleSubmit') {
              console.info('[Sentry] Trace sample freq: 1');
              return 1;
            }

            console.info('[Sentry] Trace sample freq: 0.1');
            return 0.1;
          },
          beforeSend(event, hint) {
            if (event?.extra?.feedback === 'no') {
              return event;
            }

            if (event.exception) {
              showReportDialog({ eventId: event.event_id });
            }

            return event;
          },
        });
        console.info('Sentry.io enabled');
      } else {
        console.info('Sentry.io disabled');
      }
    } catch (e) {
      console.error(e);
    }

    try {
      const app = new Application();
      await app.run();
    } catch (err) {
      console.error(err);
      captureException(err);
    }
  });
} catch (e) {
  console.error(e);
}
